import { Board } from "./types";

// Boards have no code — projects own the code. A board is addressed in the URL by a slug of its
// (unique) name, and resolved by matching that slug back to a board. Keep this the single source of
// truth for board paths so the app router and the in-designer overlay stay in lockstep.

export function slugifyBoardName(name: string): string {
  const slug: string = (name || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return slug || "board";
}

export function boardSlug(board: Board): string {
  return slugifyBoardName(board.name);
}

// Resolve a board from a URL slug (case/format-insensitive). Names are unique, so the slug is too.
export function findBoardBySlug(boards: Board[], slug: string | undefined): Board | undefined {
  if (!slug) return undefined;
  const target: string = slugifyBoardName(slug);
  return boards.find((board: Board) => boardSlug(board) === target);
}

// The project-scoped route for a board: /{domain}/board/{projectKey}/{slug} for project boards,
// /{domain}/board/multi/{slug} for cross-project boards.
export function buildBoardPath(domainName: string, board: Board): string {
  const slug: string = boardSlug(board);
  if (board.scope.kind === "multi_project") return `/${domainName}/board/multi/${slug}`;
  return `/${domainName}/board/${board.scope.projectKey}/${slug}`;
}
